import { Text } from "@fragments";

import { IconCurrencyReal } from "@tabler/icons-react";

import "./styles.scss";

export default function SplitCurrencyNotice() {
  return (
    <div className="split-currency-notice">
      <div className="split-currency-notice__icon">
        <IconCurrencyReal />
      </div>
      <div className="split-currency-notice__copy">
        <Text.label contrast={9}>
          Split aplicado a pagamentos em reais (BRL)
        </Text.label>
        <Text.span contrast={6}>
          As regras de split incidem sobre as vendas processadas em reais.
          Vendas internacionais seguem um fluxo de liquidação próprio e são
          creditadas diretamente na sua carteira Stripe, sem divisão entre
          recebedores.
        </Text.span>
      </div>
    </div>
  );
}
